import React, { useEffect, useState } from 'react';
import './LoaderStyles.scss';
import * as ReactDOM from 'react-dom';
import Timer from './Timer';

export default function TimerLoader(props) {
  const [showLoader, setShowLoader] = useState(false);
  const { loading = false, global = false, hideScreen = false } = props;

  useEffect(() => {
    if (loading) {
      const t = setTimeout(() => {
        setShowLoader(true);
      }, 5000);
      return () => clearTimeout(t);
    }
    setShowLoader(false);
  }, [loading]);

  if (!loading || !showLoader) {
    return null;
  }

  if (global) {
    return ReactDOM.createPortal(
      <Timer hideScreen={hideScreen} global={global} />,
      document.body,
    );
  }

  return (<Timer hideScreen={hideScreen} global={global} />);
}
